// src/components/IdentityChat/CreateChat.js
import React, { useState } from "react";
import { db } from "../../firebase/config";
import { collection, addDoc, serverTimestamp, doc, updateDoc, increment, setDoc } from "firebase/firestore";
import { Container, Button, Form, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

export default function CreateChat() {
  // const [chatName, setChatName] = useState("");
  const [groupAName, setGroupAName] = useState("");
  const [groupBName, setGroupBName] = useState("");
  const [myGroup, setMyGroup] = useState("");
  const [topic, setTopic] = useState("");
  const navigate = useNavigate();
  const auth = getAuth();

  const handleCreate = async () => {
    if (!groupAName || !groupBName || !myGroup || !topic) {
      alert("Please complete all fields.");
      return;
    }

    const user = auth.currentUser;

    const docRef = await addDoc(collection(db, "conversations"), {
      topic,
      groupA: { name: groupAName },
      groupB: { name: groupBName },
      createdAt: serverTimestamp(),
      creatorId: user.uid,
      currentTurn: myGroup,
      hasStarted: false,
      lastOfficialAt: serverTimestamp()
    });
    // save creator membership
    await setDoc(
      doc(db, "userConversations", `${user.uid}_${docRef.id}`),
      {
        userId: user.uid,
        conversationId: docRef.id,
        group: myGroup,
        joinedAt: new Date()
      }
    );

    await setDoc(
      doc(db, "users", user.uid),
      {
        stats: {
          groupsStarted: increment(1),
          groupsJoined: increment(1)
        }
      },
      { merge: true }
    );

    navigate(`/chat/${docRef.id}?group=${myGroup}`);
  };

  return (
    <Container className="vh-100 d-flex align-items-center justify-content-center bg-light">
      <Card className="p-4 shadow border-0 rounded-4" style={{ width: "500px" }}>
        <h4 className="fw-bold mb-3 text-center" style={{color: "#043b07", marginBottom: "20px"}}>Create New Chat</h4>

        <Form>
          {/* <Form.Group className="mb-3">
            <Form.Label>Chat Name</Form.Label>
            <Form.Control
              value={chatName}
              onChange={(e) => setChatName(e.target.value)}
              placeholder="Yoruba vs Igbo Dialogue"
            />
          </Form.Group> */}

          <Form.Group className="mb-3 mt-3">
            <Form.Label>1st Group's Name</Form.Label>
            <Form.Control
              value={groupAName}
              onChange={(e) => setGroupAName(e.target.value)}
              placeholder="e.g., Gen Z"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>2nd Group's Name</Form.Label>
            <Form.Control
              value={groupBName}
              onChange={(e) => setGroupBName(e.target.value)}
              placeholder="e.g., Millennials"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Topic</Form.Label>
            <Form.Control
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
              placeholder="e.g., Is Marriage Necessary?"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Choose your group ? </Form.Label>
            <div>
              <Form.Check
                inline
                label={groupAName || "1st Group"}
                name="myGroup"
                type="radio"
                value="A"
                onChange={(e) => setMyGroup(e.target.value)}
              />
              <Form.Check
                inline
                label={groupBName || "2nd Group"}
                name="myGroup"
                type="radio"
                value="B"
                onChange={(e) => setMyGroup(e.target.value)}
              />
            </div>
          </Form.Group>

          <div className="d-grid">
            {/* Button */}
            <Button
              className="rounded-pill"
              style={{
                background: "linear-gradient(135deg,#2d512f,#318333)",
                border: "none",
                padding: "12px",
                fontWeight: 600,
                fontSize: "16px",
                marginTop: "20px"
              }}
              onClick={handleCreate}
            >
              Start Chat
            </Button>
          </div>
        </Form>
      </Card>
    </Container>
  );
}